import React from 'react';
import {
  Descriptions as AntDescription,
  DescriptionsProps as AntdDescriptionProps
} from 'antd';
import { DescriptionsItemProps } from 'antd/lib/descriptions/Item';
import { BaseRecord } from 'app/context/data/types';
import get from 'lodash/get';

type DescriptionsProps<T = BaseRecord> = Partial<AntdDescriptionProps> & {
  items: Array<
    Partial<DescriptionsItemProps> & {
      dataIndex: string;
      render?: (
        value: unknown,
        record: T,
        meta?: BaseRecord
      ) => React.ReactNode;
    }
  >;
  value: T;
  meta?: T;
};

const Descriptions = (props: DescriptionsProps) => {
  const { value, meta, items = [], ...descriptionsProps } = props;

  return (
    <AntDescription {...(descriptionsProps as any)}>
      {items.map((item, index) => {
        const { render, dataIndex, ...itemProps } = item;
        const itemValue = get(value, dataIndex);
        return (
          <AntDescription.Item key={`${index}_${dataIndex}`} {...itemProps}>
            {render ? render(itemValue, value, meta) : itemValue}
          </AntDescription.Item>
        );
      })}
    </AntDescription>
  );
};

export default Descriptions;
